// extracted by mini-css-extract-plugin
export var Preloader = "Preloader-module--Preloader--ap0gf";
export var Wrap = "Preloader-module--Wrap--guas1";
export var Icon = "Preloader-module--Icon--0+SRy";
export var LogoAnimate = "Preloader-module--LogoAnimate--5uRop";
export var Logo = "Preloader-module--Logo--dej7H";
export var Count = "Preloader-module--Count--pg41J";
export var Progress = "Preloader-module--Progress--fVarQ";
export var arrowLeft = "Preloader-module--arrowLeft--KsfNn";
export var arrowRight = "Preloader-module--arrowRight--3QT0i";